/**
@ngdoc directive
@name preventInvalidSubmit

@description
Apply on form element - prevents submission of invalid form.<br />
(Please also see allowInvalidSubmit [buttonDirectives.js]).
*/
(function() {

    var preventInvalidSubmit = function() {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            require: '^form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {

                // allow invalid submit (another directive) broadcast (some forms needs to have the option to be saved invalid)
                var allowInvalidSubmit = false;
                scope.$on('save-invalid-form', function($event){
                    allowInvalidSubmit = true;
                });

                element.bind("submit", function(event){
                    // if invalid form
                    if(formCtrl.$invalid && !allowInvalidSubmit) {
                        event.preventDefault();
                        allowInvalidSubmit = false;
                        setSubmitted(formCtrl); // instead of // formCtrl.$setSubmitted(); // see comment for function setSubmitted

                        if(element.closest('.modal').length){ // run in modal window?
                            $('.modal').animate({ scrollTop: 0 }, 'slow'); // modal
                        } else {
                            $("html, body").animate({ scrollTop: 0 }, "slow"); // TODO: form.offset().top ? element.offset().top ?
                        }
                    }
                });

                // sets all children ng-forms submitted (no such default functionality - as per: https://github.com/angular/angular.js/issues/10071)
                function setSubmitted(form) {
                    form.$setSubmitted();
                    angular.forEach(form, function(item) {
                        if(item && item.$$parentForm === form && item.$setSubmitted) {
                            setSubmitted(item);
                        }
                    });
                }

            }

        };
    }
    angular.module('app').directive('preventInvalidSubmit', preventInvalidSubmit);

}());


